"use strict";
/**
 * @module "ethpm/package"
 */
Object.defineProperty(exports, "__esModule", { value: true });
